import Filter from '@components/Filter';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    sort: 'IssuedAtDesc' | 'ExpiresAtAsc'
    setSort: (v: 'IssuedAtDesc' | 'ExpiresAtAsc') =>void;
}

function CouponFilter({ sort, setSort }:Props) {
    const { t } = useTranslation('coupon');
    return (
        <Wrapper>
            <Filter title={t('filter.title')} sort={sort}
                setSort={setSort}
                sortItems={[
                    { value: 'IssuedAtDesc', label: t('filter.issuedAtDesc') },
                    { value: 'ExpiresAtAsc', label: t('filter.expiresAtAsc') },
                ]}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 12px 16px;
`;

export default CouponFilter;
